import React, { useEffect, useState } from "react";
import { Title } from "react-admin";

import { usersProvider } from "../../providers/users";
import { adminsProvider } from "../../providers/admins";
import { organizationsProvider, Organization } from "../../providers/organizations";
import { controllersProvider } from "../../providers/controllers";

import CountCard from "../CountCard";

import "./Dashboard.css";
import { getIsAuthenticated } from "../../utils/user";

type OrgRow = Organization & {
  members?: any[];
  controllers?: any[];
};

const Dashboard = () => {
  const isAuth = getIsAuthenticated();
  const [orgs, setOrgs] = useState<OrgRow[]>([]);

  useEffect(() => {
    if (isAuth) {
      organizationsProvider.getMany().then((data) => setOrgs((data as OrgRow[]) ?? []));
    }
  }, [isAuth]);

  return (
    <div className="v-dashboard">
      <Title className="v-dashboard__header-title" title={"Dashboard"}></Title>
      <h1 className="v-dashboard__page-title">Dashboard</h1>
      {!isAuth ? (
        <div className="v-dashboard__loader">
          <span className="loader" />
        </div>
      ) : (
        <>
          <div className="v-dashboard__cards">
            <CountCard fetch={usersProvider.getCount} title="Users" to="/users" />
            <CountCard fetch={organizationsProvider.getCount} title="Organizations" to="/organizations" />
            <CountCard fetch={adminsProvider.getCount} title="Admins" to="/admins" />
            <CountCard fetch={controllersProvider.getCount} title="Controllers" to="/controllers" />
          </div>

          <div className="v-dashboard__org-table-wrapper">
            <h2 className="v-dashboard__org-table-title">Organizations Overview</h2>
            <table className="v-dashboard__org-table">
              <thead>
                <tr>
                  <th>Organization</th>
                  <th>Users</th>
                  <th>Controllers</th>
                </tr>
              </thead>
              <tbody>
                {orgs.map((org, index) => (
                  <tr key={org.id} className={index % 2 === 0 ? "row-dark" : "row-darker"}>
                    <td>{org.name}</td>
                    <td>{org.members?.length ?? "-"}</td>
                    <td>{org.controllers?.length ?? "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
